<div class="commonPopup">
  <ng-template pTemplate="header"></ng-template>
  <div class="trialCont">
    <!-- Image Section -->
    <div class="img">
      <img src="/assets/images/html/Trial-Expired-2.webp" alt="Plan Expired" />
    </div>

    <!-- Content Section -->

    <div class="textCont">
      <div>
        <h1>Your Plan Has Expired</h1>
        <p>
          Your access has ended! Renew your plan now to continue using powerful tools for social
          media management, team collaboration, and AI-driven content creation.
        </p>

        <!-- Features List -->
        <ul>
          <li>
            ✅
            <div>
              <strong>Effortless Social Media Management</strong>
              <p>Stay organized with an all-in-one content calendar and scheduling tools.</p>
            </div>
          </li>
          <li>
            🤖
            <div>
              <strong>AI-Powered Content Creation</strong>
              <p>
                Generate engaging posts using AI-driven prompts, and optimize your reach with smart
                hashtag tools.
              </p>
            </div>
          </li>
          <li>
            📊
            <div>
              <strong>Advanced Analytics & Insights</strong>
              <p>Track performance across platforms with real-time data to refine your strategy.</p>
            </div>
          </li>
          <li>
            <i class="pi pi-verified"></i>
            <div>
              <strong>Seamless Team Collaboration</strong>
              <p>
                Work with your team—share drafts, provide feedback, and approve content with ease.
              </p>
            </div>
          </li>
        </ul>
      </div>
      <!-- Renew Button Section -->
      <div class="d-md-flex justify-content-end bottomBtn">
        <p-button
          label="Renew Now"
          icon="pi pi-refresh"
          iconPos="right"
          (click)="onGoPremium()"
          routerLink="/plans"
        />
      </div>
    </div>
  </div>
</div>
